import { useCallback, useEffect, useRef } from 'react'
import { DOCK_W_MAX, DOCK_W_MIN } from '../../stores/chatDockStore'

/**
 * Sohbet dock sol kenarı — sürükleyerek daralt/genişlet (akordeon).
 * Çok daraya çekilirse (collapseBelow) panel kapanır.
 */
export default function DockResizeHandle({ width, onChange, onCollapse, onDragEnd, collapseBelow = 240 }) {
  const drag = useRef(null)

  const onMove = useCallback((e) => {
    const d = drag.current
    if (!d) return
    // Sol kenar: sağa sürükleyince panel daralır
    const next = d.startW - (e.clientX - d.startX)
    onChange(Math.min(DOCK_W_MAX, Math.max(collapseBelow - 40, next)))
  }, [onChange, collapseBelow])

  const finish = useCallback((e) => {
    if (!drag.current) return
    const d = drag.current
    drag.current = null
    document.body.style.cursor = ''
    document.body.style.userSelect = ''
    const next = d.startW - ((e?.clientX ?? d.startX) - d.startX)
    if (next < collapseBelow) {
      onCollapse?.()
    } else {
      onChange(Math.min(DOCK_W_MAX, Math.max(DOCK_W_MIN, next)))
    }
    onDragEnd?.()
  }, [onChange, onCollapse, onDragEnd, collapseBelow])

  useEffect(() => {
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', finish)
    window.addEventListener('pointercancel', finish)
    return () => {
      window.removeEventListener('pointermove', onMove)
      window.removeEventListener('pointerup', finish)
      window.removeEventListener('pointercancel', finish)
    }
  }, [onMove, finish])

  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label="Sohbet panelini daralt veya genişlet"
      aria-valuenow={Math.round(width)}
      aria-valuemin={DOCK_W_MIN}
      aria-valuemax={DOCK_W_MAX}
      title="Sürükle: daralt / genişlet · Çift tık: kapat"
      onPointerDown={(e) => {
        e.preventDefault()
        drag.current = { startX: e.clientX, startW: width }
        document.body.style.cursor = 'col-resize'
        document.body.style.userSelect = 'none'
      }}
      onDoubleClick={(e) => {
        e.preventDefault()
        onCollapse?.()
      }}
      className="group relative w-2 shrink-0 cursor-col-resize self-stretch z-10
                 bg-gray-100 hover:bg-violet-200 active:bg-violet-300 transition-colors
                 border-r border-gray-200"
    >
      {/* Görünür tutamak — akordeon olduğu belli olsun */}
      <span className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                       flex flex-col gap-0.5 opacity-80 group-hover:opacity-100">
        <span className="w-0.5 h-3 rounded-full bg-gray-400 group-hover:bg-violet-600" />
        <span className="w-0.5 h-3 rounded-full bg-gray-400 group-hover:bg-violet-600" />
        <span className="w-0.5 h-3 rounded-full bg-gray-400 group-hover:bg-violet-600" />
      </span>
    </div>
  )
}
